import { jsx as _jsx } from "react/jsx-runtime";
const baseStyle = {
    borderRadius: 8,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "0.875rem",
    fontWeight: 600,
    letterSpacing: "0.4px",
    lineHeight: 1.2,
    borderStyle: "solid",
    borderWidth: 1,
    whiteSpace: "nowrap",
};
const sizeStyle = {
    compact: { padding: "8px 12px" },
    regular: { padding: "10px 16px" },
    dialog: {
        padding: "12px 20px",
        borderRadius: 10,
        fontSize: 15,
        fontWeight: 700,
    },
};
const PRIMARY = "var(--color-primary)";
const DANGER = "var(--color-danger)";
const variantStyle = {
    primary: {
        background: PRIMARY,
        borderColor: PRIMARY,
        color: "var(--color-on-accent)",
    },
    secondary: {
        background: "var(--island-bg-color)",
        borderColor: "var(--dialog-border-color)",
        color: "inherit",
    },
    danger: {
        background: DANGER,
        borderColor: DANGER,
        color: "var(--color-on-accent)",
    },
};
const disabledStyle = {
    cursor: "not-allowed",
    opacity: 0.6,
};
/**
 * The single primary/secondary/danger button treatment for the whole app.
 *
 * Colors come from Excalidraw's design tokens rather than literals, so surfaces
 * inside the `.excalidraw` DOM adapt to dark mode automatically. The fallbacks
 * match Excalidraw's light theme and apply only if the token is missing; the app
 * republishes the palette at `:root` so it resolves outside that subtree too.
 *
 * See docs/designs/message-taxonomy.md § 6.1.
 */
export function Button({ variant = "secondary", size = "regular", disabled, style, children, type = "button", ...rest }) {
    return (_jsx("button", { type: type, disabled: disabled, "data-variant": variant, style: {
            ...baseStyle,
            ...sizeStyle[size],
            ...variantStyle[variant],
            ...(disabled ? disabledStyle : null),
            ...style,
        }, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map